import type { UserAuth } from '~/schemas/auth'

export default defineNuxtRouteMiddleware((to, from) => {
  const { user } = useSanctumAuth<UserAuth>()

  if (!user.value?.current_role) return

  to.meta.layout = resolveLayout(
    user.value.current_role,
    to.path,
    user.value.platform_subscriber_context,
  )
})
